import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownHeader,
  CDropdownItem,
  CDropdownDivider,
  CAvatar,
  CRow,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { Konfirm } from '../helpers/onConfirm';
import { UFunc } from '../helpers/functions'

const pjson 			= require('../../package.json');

const ContHeaderProfile = (props) => {
	const { setToken,setLoading,showToast,clearStorage } = props; 

	const uNavigate 	= useNavigate();

	const uTokenobj		= JSON.parse(localStorage.getItem("token")||"{}");
	const uBahasaob  	= useSelector(state => state.listBahasa);

	const uAvatardefault= () => {  
		switch((uTokenobj.userhak||"FO").toUpperCase()) {
			case "SUPERADMIN":
				return pjson.homepage+"api/images/img_superadmin.png";
				break
			case "PENGELOLA":
				return pjson.homepage+"api/images/img_pengelola.png";
				break
			case "MANAJER":
				return pjson.homepage+"api/images/img_manajer.png";
				break
			case "FO":
				return pjson.homepage+"api/images/img_fo.png";
				break
			case "GUDANG":
				return pjson.homepage+"api/images/img_gudang.png";
				break
			default:
				return pjson.homepage+"api/images/img_gudang.png";
		}
	}

	const hdlKlikLogout	= async() => {
		if(await Konfirm(uBahasaob.confirm_logout||"Apakah Yakin Akan Logout ?")) ApiProseslogout();
		//if(await window.confirm(uBahasaob.confirm_logout||"Apakah Yakin Akan Logout ?")) ApiProseslogout();
	}

	const contentCabangtext = () => {
		const vCabangArr= JSON.parse(localStorage.getItem("cabanglist") || "[]");
		const vCabangid	= localStorage.getItem("cabangidselect") || "0";
		const vArridx	= UFunc.getObjectIndeks(vCabangArr,vCabangid);

		return vCabangArr[vArridx].nama_cabang || "UNDF";
	}

	const ApiProseslogout = () => {
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout	= setTimeout(() => {
			setLoading(false);
			clearStorage();
			showToast(uBahasaob.pesan_hasloggedout||"Anda Telah Logout..");
			setToken("");
		},2000); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenobj.userinit,
			send_device	: pjson.name
		});
		const vURLs	= pjson.homepage+"api/api_login/pr_logout";
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST", mode: "cors",
			cache: "default", body: vDATAS,
		}).then((response)=>{ if (response.status === 200) return response.json(); })
		.then((output_string) => {
			setLoading(false);
			if(output_string.sukses) {
		    	clearStorage();
				setToken("");
				showToast(uBahasaob.pesan_hasloggedout||"Anda Telah Logout..");
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(ContHeaderProfile - ApiProseslogout) output_string.errors: "+output_string.errors);
				var vMsg;
				if(pjson.mydefault.environment==="development")
					vMsg = output_string.errors;
				else vMsg = pjson.mydefault.msgFetchError;

				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setToken("");
			}
		}) .catch((error) =>{
			setLoading(false);
			console.log("(ContHeaderProfile - ApiProseslogout) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(""),"ERROR");
		});
	}

	return (
	<>
		<small className="text-primary classfontsmaller d-none d-md-block">
		&middot; {contentCabangtext()} &middot;
		</small>

		<CDropdown className="ms-2">
		<CDropdownToggle className="p-0 bg-transparent border-0" caret={false}>
			<CAvatar src={uAvatardefault()} size="md"/>
		</CDropdownToggle>

		<CDropdownMenu className="pt-0" placement="bottom-end">
        	<CDropdownHeader className="bg-light fw-semibold py-2 px-4 text-center">
	          	<div className="mb-2"><CIcon icon="cilUser" height={30} /></div>
				<strong>{(UFunc.Usercaptionfilter(uTokenobj.usercaption)).toUpperCase()}</strong>
				<div className="classfontsmaller">{"Hak Akses: "+(uBahasaob["hakuser_"+(uTokenobj.userhak||"").toLowerCase()]||(uTokenobj.userhak||"")).toUpperCase()}</div>
				<small className="text-primary classfontsmaller d-md-none">
					&middot; Cab: {contentCabangtext()} &middot;
				</small>
        	</CDropdownHeader>

			<CDropdownItem className="py-2 px-4 classcursorpointer " 
				onClick={()=>uNavigate("/a1profile")}>
			<CIcon icon="cilUser" className="me-2 classverticalmiddle" height={20}/>{uBahasaob.caption_profileanda||"Profile Anda"}
			</CDropdownItem>

			<CDropdownItem className="py-2 px-4 classcursorpointer " onClick={()=>hdlKlikLogout()}>
			<CIcon icon="cilAccountLogout" className="me-2 classverticalmiddle" height={20}/>{uBahasaob.caption_logout||"Logout Aplikasi"}
			</CDropdownItem>
		</CDropdownMenu>
		</CDropdown>
	</>
	)//>
}

export default ContHeaderProfile
	